"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconEdit = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 20",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M17.7102735,4.04256243 C18.1002795,3.6525564 18.1002795,3.00254637 17.7102735,2.63254065 L15.3702373,0.292504517 C15.0002316,-0.0975015056 14.3502216,-0.0975015056 13.9602156,0.292504517 L12.1201872,2.12253278 L15.8702451,5.87259068 M0,14.2527201 L0,18.002778 L3.75005791,18.002778 L14.8102287,6.93260705 L11.0601708,3.18254915 L0,14.2527201 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconEdit')(IconEdit);